export default ['en', 'el', 'de', 'fr']
